import { useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { apiClient } from '../../utils/api';

export const useNotionOptionsApi = () => {
  const { user } = useAuth();

  const getUsersDatabaseId = useCallback(async () => {
    const headers = {};
    
    // Add telegram ID header if user is authenticated
    if (user?.telegramId) {
      headers['x-telegram-id'] = user.telegramId.toString();
    }

    const response = await apiClient.get('/api/notion-data/users-database-id', { headers });
    return response.data;
  }, [user]);

  const getNotionSelectOptions = useCallback(async (databaseId) => {
    const headers = {};
    
    // Add telegram ID header if user is authenticated
    if (user?.telegramId) {
      headers['x-telegram-id'] = user.telegramId.toString();
    }

    const response = await apiClient.get('/api/notion-data/select-options', {
      params: { databaseId },
      headers
    });

    return response.data;
  }, [user]);

  const getDatabasesFromParentPage = useCallback(async () => {
    const headers = {};
    
    // Try to get telegramId from multiple sources
    let telegramId = user?.telegramId;
    
    if (!telegramId && typeof window !== 'undefined') {
      // Try Telegram WebApp initDataUnsafe
      if (window.Telegram?.WebApp?.initDataUnsafe?.user?.id) {
        telegramId = window.Telegram.WebApp.initDataUnsafe.user.id;
      }
      // Try parsing initData string
      else if (window.Telegram?.WebApp?.initData) {
        try {
          const params = new URLSearchParams(window.Telegram.WebApp.initData);
          const userStr = params.get('user');
          if (userStr) {
            const tgUser = JSON.parse(decodeURIComponent(userStr));
            telegramId = tgUser.id;
          }
        } catch (e) {
          // Ignore parse errors
        }
      }
    }
    
    if (telegramId) {
      headers['x-telegram-id'] = telegramId.toString();
    }

    const response = await apiClient.get('/api/notion-data/databases', { headers });
    return response.data;
  }, [user]);

  return {
    getUsersDatabaseId,
    getNotionSelectOptions,
    getDatabasesFromParentPage
  };
};

